<template>
  <div class="infoDropdown">
    <div class="infoDropdown__inner">
      <div class="infoDropdown__title">Biuro obsługi klienta</div>
      <div class="infoDropdown__item">
        <div class="infoDropdown__itemLeft">
          <span class="infoDropdown__itemIcon icon-phone" />
        </div>
        <div class="infoDropdown__itemContent">
          <a href="tel:801 800 801" class="infoDropdown__itemPhone"> 801 800 801</a>
          <div class="infoDropdown__itemPhoneText">opłata 0,29zł netto/min</div>
          <table class="infoDropdown__itemHours">
            <tbody>
              <tr>
                <th>pon. - pt.</th>
                <td>8:00 - 16:00</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="infoDropdown__item">
        <div class="infoDropdown__itemLeft">
          <span class="infoDropdown__itemIcon infoDropdown__itemIcon--letter icon-letter" />
        </div>
        <div class="infoDropdown__itemContent">
          <div class="infoDropdown__itemText">
            {{ $t('message') }}
          </div>
          <a href="mailto:info@ofix.pl" class="infoDropdown__itemEmail"> info@ofix.pl </a>
        </div>
      </div>
      <v-button
        :text="$t('chat')"
        theme="purple"
        full-width
        class="infoDropdown__button"
        @click="showChat"
      />
    </div>
  </div>
</template>

<script>
import chatMixin from '~/mixins/chat.js';
import VButton from '~/components/VButton';

export default {
  name: 'InfoDropdown',
  components: {
    VButton,
  },
  mixins: [chatMixin],
};
</script>

<style lang="scss">
.infoDropdown {
  $root: &;
  background-color: $cWhite;
  position: absolute;
  z-index: 2;
  right: -1px;
  top: 80%;
  padding-top: 0;
  cursor: default;
  opacity: 0;
  pointer-events: none;
  transition: opacity $tr, top $tr;

  &__inner {
    position: relative;
    width: 29rem;
    padding: 2.5rem;
    box-shadow: 0 10px 20px rgba(23, 25, 51, 0.1);
    border: 1px solid $cAddLight;
    border-radius: 0 0 4px 4px;

    &:before {
      content: '';
      position: absolute;
      transform: rotate(45deg);
      right: 23px;
      top: -7px;
      width: 12px;
      height: 12px;
      background-color: $cWhite;
      border-left: 1px solid $cAddLight;
      border-top: 1px solid $cAddLight;
    }
  }

  &__title {
    margin-bottom: 2.3rem;
    font-size: 1.5rem;
    line-height: 1.9rem;
    font-weight: 700;
    color: $cMainDark;
  }

  &__item {
    display: flex;
    margin-bottom: 2rem;
  }

  &__itemLeft {
    width: 4.4rem;
  }

  &__itemContent {
    flex: 1;
  }

  &__itemIcon {
    padding-left: 2px;
    font-size: 2.2rem;
    line-height: 2.2rem;
    color: $cSec;

    &--letter {
      position: relative;
      top: 2px;
      font-size: 1.7rem;
      line-height: 1.7rem;
    }
  }

  &__itemPhone {
    display: block;
    font-family: $fSecond;
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: $cMainDark;
    font-weight: 400;
    transition: color $tr;

    &:hover {
      color: $cSec;
    }
  }

  &__itemPhoneText {
    font-size: 1.2rem;
    line-height: 1;
    font-weight: 400;
  }

  &__itemHours {
    margin-top: 0.5rem;
    font-size: 1.4rem;
    line-height: 2.2rem;

    th {
      text-align: left;
      padding-right: 1.5rem;
    }

    td {
      color: $cMainDark;
    }
  }

  &__itemText {
    font-size: 1.5rem;
    line-height: 1.9rem;
    font-weight: 600;
    color: $cMainDark;
  }

  &__itemEmail {
    font-size: 1.4rem;
    line-height: 2.2rem;
    transition: color $tr;

    &:hover {
      color: $cSec;
    }
  }

  &__button {
    margin-top: 0.7rem;
  }
}
</style>
